import { dispatch } from '@ngneat/effects';

import { AuthErrorMap } from '../models/auth-config';
import { setAuthErrorMap } from '../repositories/auth.actions';

/**
 * Update the authErrorMap object of the AuthConfig with new strings for the provided error types.
 * Useful for when your application changes its display language.
 *
 * @param authErrorMap Mapping of keys to translated strings used for different auth error types
 */
export const updateAuthErrorMap = (authErrorMap: AuthErrorMap) => {
  dispatch(setAuthErrorMap({ authErrorMap }));
};
